const _0x37a427 = _0x2d1b;
(function (_0x539080, _0x497bd0) {
    const _0x153b33 = _0x2d1b,
        _0x47dc7d = _0x539080();
    while (!![]) {
        try {
            const _0x339dd6 =
                -parseInt(_0x153b33(0x149)) / 0x1 +
                -parseInt(_0x153b33(0x186)) / 0x2 +
                -parseInt(_0x153b33(0x133)) / 0x3 +
                parseInt(_0x153b33(0x129)) / 0x4 +
                parseInt(_0x153b33(0x11a)) / 0x5 +
                parseInt(_0x153b33(0x137)) / 0x6 +
                (parseInt(_0x153b33(0x184)) / 0x7) * (parseInt(_0x153b33(0x1a5)) / 0x8);
            if (_0x339dd6 === _0x497bd0) break;
            else _0x47dc7d["push"](_0x47dc7d["shift"]());
        } catch (_0x20221f) {
            _0x47dc7d["push"](_0x47dc7d["shift"]());
        }
    }
})(_0x5610, 0xbf544);
let osMap, osMap2;
const geocoder = new google[_0x37a427(0x152)][_0x37a427(0x16d)](),
    region = "UK",
    fractionDigits = 0x5,
    fixSetUp = 0x1e,
    fixPrice = 0.0025,
    smooths = {
        "Digimura\x20Ready\x20Pasted\x20Classic": { price: 0.0029, selected: !![] },
        "Digimura\x20Premium\x20Smooth": { price: 0.0032 },
        "Dreamscape\x20Premium\x20Durable": { price: 0.0035 },
        "FabriTac\x20Self\x20Adhesive": { price: 0.0037 },
    },
    title = _0x37a427(0x17d) + _0x37a427(0xef) + _0x37a427(0x1b0) + "\x20Mural\x20Size:\x20{widthMural}cm\x20x\x20{heightMural}cm." + _0x37a427(0x126) + _0x37a427(0x17c),
    proofsTitle = _0x37a427(0x19d) + _0x37a427(0x142),
    muralAdditionSize = 0xa,
    useVAT = 0x14,
    proofsOnlyPrice = 0xf,
    setup_position = [-0.13437621090811594, 51.5005364518253],
    key = _0x37a427(0x1b2),
    osUrl = _0x37a427(0x19a);
const cmapHubDimensions = Boolean(document.querySelector('.custom-maps-hub'));
let lastWidth = cmapHubDimensions ? null : 0x15e,
    lastHeight = cmapHubDimensions ? null : 0xfa;
const BOX_WIDTH = 0x1900,
    BOX_HEIGHT = cmapHubDimensions ? BOX_WIDTH : (lastHeight / lastWidth) * BOX_WIDTH,
    postCodeStartZoom = 0xd;
let ratioHeight = lastHeight / BOX_HEIGHT,
    ratioWidth = lastWidth / BOX_WIDTH,
    sendProof = ![];
const max_zoom = 0xa,
    min_zoom = 0x7,
    EPSG_3857_POINT_SCALE_FACTOR = 1.243900282,
    BOX_SCALE_MAX_LIMIT = 0x2710,
    BOX_SCALE_MIN_LIMIT = 0x8e8,
    METRES_IN_KM = 0x3e8;
let cathed = ![],
    isBoxShowed = ![],
    Area,
    calcPrice,
    catchBounds,
    range,
    vectors,
    openLayersBox,
    transform,
    vectors2,
    box2,
    transform2,
    currentBounds;
(window[_0x37a427(0xf8)] = {
    Proj: function (_0x259e0d) {
        return proj4(Proj4js["defs"][_0x259e0d]);
    },
    defs: proj4[_0x37a427(0x123)],
    transform: proj4,
}),
    (Proj4js["defs"][_0x37a427(0x12e)] = _0x37a427(0x175)),
    (Proj4js["defs"][_0x37a427(0xf4)] = _0x37a427(0x18c)),
    (Proj4js[_0x37a427(0x123)][_0x37a427(0x1b6)] = "+proj=longlat\x20+ellps=WGS84\x20+datum=WGS84\x20+no_defs"),
    (Proj4js[_0x37a427(0x123)][_0x37a427(0xfe)] = _0x37a427(0x156));
function setMainMap() {
    const _0x379532 = _0x37a427;
    var _0x4fbf10 = document[_0x379532(0x118)](_0x379532(0x1a3)),
        _0x3c95b8 = document[_0x379532(0x118)]("map2"),
        _0x5870c3 = document["getElementById"](_0x379532(0x110));
    (_0x4fbf10["style"][_0x379532(0x17b)] = _0x379532(0x171)), (_0x3c95b8["style"][_0x379532(0x17b)] = _0x379532(0x154)), (_0x5870c3[_0x379532(0x11d)] = _0x379532(0x155));
    changeprice();
}
function setSecondMap() {
    const _0x1a4cca = _0x37a427,
        _0xcb648c = document[_0x1a4cca(0x118)]("map"),
        _0x55dc45 = document["getElementById"](_0x1a4cca(0x13a)),
        _0x32ce63 = document[_0x1a4cca(0x118)](_0x1a4cca(0x110));
    (_0xcb648c[_0x1a4cca(0xf7)][_0x1a4cca(0x17b)] = _0x1a4cca(0x154)), (_0x55dc45[_0x1a4cca(0xf7)][_0x1a4cca(0x17b)] = _0x1a4cca(0x171)), (_0x32ce63[_0x1a4cca(0x11d)] = "Return\x20To\x20Map\x20Area\x20Selection\x20Tool");
}
function numberFormat(_0x727d0e) {
    const _0x57092c = _0x37a427;
    return _0x727d0e[_0x57092c(0x182)](0x2)[_0x57092c(0x1a8)](/\d(?=(\d{3})+\.)/g, "$&,");
}

function getActiveCurrencyCode() {
    return window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : null;
}

function getCurrencyDecimals(code) {
    if (!code) return 2;
    try {
        return new Intl.NumberFormat(undefined, { style: "currency", currency: code }).resolvedOptions().maximumFractionDigits;
    } catch (e) {
        return 2;
    }
}

function formatMoneyNumber(value) {
    var decimals = getCurrencyDecimals(getActiveCurrencyCode());
    try {
        return new Intl.NumberFormat(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(value);
    } catch (e) {
        return value.toFixed(decimals);
    }
}

function getMoneySample() {
    var el = document.getElementById("inpP2") || document.querySelector(".pmprice") || document.getElementById("inpP");
    if (el) return (el.value || el.textContent || "").trim();
    var opt = document.querySelector("#map_var option:checked");
    if (opt) return (opt.getAttribute("data-price") || "").trim();
    return "";
}

function getCurrencyAffixes(sample) {
    var s = (sample || "").trim();
    var prefix = "";
    var suffix = "";
    var prefixMatch = s.match(/^[^\\d]+/);
    if (prefixMatch) prefix = prefixMatch[0];
    var suffixMatch = s.match(/[^\\d]+$/);
    if (suffixMatch) suffix = suffixMatch[0];
    return { prefix: prefix, suffix: suffix };
}

function formatCurrency(value) {
    var formatted = formatMoneyNumber(value);
    var sample = getMoneySample();
    var aff = getCurrencyAffixes(sample);
    if (aff.prefix || aff.suffix) return aff.prefix + formatted + aff.suffix;
    var code = getActiveCurrencyCode();
    if (code) {
        try {
            return new Intl.NumberFormat(undefined, { style: "currency", currency: code }).format(value);
        } catch (e) {}
    }
    return formatted;
}
var cmapPostcodeSearchTimer;
var cmapPostcodeSearchRequest = 0;
var cmapPostcodePending = '';
var cmapPostcodeConfirmed = '';
var cmapPostcodeStyle = '';
var cmapMatchedLocation = '';

function cmapRefreshLocationMessage() {
    var status = document.getElementById('cmap-location-status');
    if (!status || !cmapMatchedLocation) return;
    var ready = Boolean(currentBounds);
    status.textContent = 'Location found: ' + cmapMatchedLocation + '. ';
    if (ready) {
        status.append('You can select your map area below.');
    } else {
        var mobileCopy = document.createElement('span');
        mobileCopy.className = 'cmap-location-status__mobile';
        mobileCopy.textContent = 'Your map is centred below.';
        var desktopCopy = document.createElement('span');
        desktopCopy.className = 'cmap-location-status__desktop';
        desktopCopy.textContent = 'Your map is centred on this location.';
        status.append(mobileCopy, desktopCopy, ' Enter your wall size to set the crop area.');
    }
    document.dispatchEvent(new CustomEvent('cmap:crop-readiness', { detail: { ready: ready } }));
}

function SearchPC(immediate) {
    $("#scale_extents").show();

    var postcodeField = document.getElementById("inpPostCodChange");
    if (!postcodeField) return;

    var postcode = postcodeField.value.trim();
    var mapStyle = document.getElementById('selTM');
    var style = mapStyle ? mapStyle.value : '';
    var ukOnly = ['10', 'E25', '50', '250', '1000'].indexOf(style) !== -1;
    var mobileHub = postcodeField.closest('.custom-maps-hub') && window.matchMedia('(max-width: 749px)').matches;
    var statusElement = document.getElementById('cmap-location-status');
    var searchButton = document.querySelector('.cmap-find-location');
    function searchState(message, busy, invalid) {
        if (statusElement) statusElement.textContent = message;
        if (searchButton) {
            searchButton.disabled = busy;
            searchButton.textContent = busy ? 'Finding…' : 'Find';
        }
        if (statusElement) postcodeField.setAttribute('aria-invalid', String(Boolean(invalid)));
    }
    if (immediate === true && postcode && style === cmapPostcodeStyle && postcode === cmapPostcodePending) return;
    document.dispatchEvent(new CustomEvent('cmap:location-selection', { detail: { confirmed: false } }));
    clearTimeout(cmapPostcodeSearchTimer);
    var requestId = ++cmapPostcodeSearchRequest;
    cmapPostcodePending = '';
    cmapPostcodeConfirmed = '';
    cmapMatchedLocation = '';
    cmapPostcodeStyle = style;
    searchState('', false, false);

    // Mobile searches are explicit; edits still invalidate outstanding responses.
    if (mobileHub && immediate !== true) return;
    var completePostcode = /^(GIR\s?0AA|[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2})$/i.test(postcode);
    var postcodeFragment = /^[A-Z]{1,2}\d[A-Z\d]?(\s*\d[A-Z]?)?$/i.test(postcode);
    if (postcode.length < 3 || (ukOnly && postcodeFragment && !completePostcode)) {
        if (immediate) searchState('Enter a complete postcode, town, village or place name.', false, true);
        return;
    }

    function findLocation() {
        if (typeof geocoder === "undefined" || typeof google === "undefined" || typeof OpenLayers === "undefined" || !osMap) {
            searchState('The map is still loading. Please try again.', false, false);
            return;
        }

        cmapPostcodePending = postcode;
        searchState('Finding your location…', true, false);
        var query = { address: postcode };
        if (ukOnly) query.componentRestrictions = { country: 'GB' };
        geocoder.geocode(query, function (results, status) {
            // Ignore results from an earlier keystroke so the box always follows
            // the location currently in the field.
            if (requestId !== cmapPostcodeSearchRequest || postcodeField.value.trim() !== postcode || (mapStyle && mapStyle.value !== style)) return;
            cmapPostcodePending = '';

            var result = results && results.find(function (candidate) {
                var components = candidate.address_components || [];
                var inUK = components.some(function (part) { return part.types.indexOf('country') !== -1 && part.short_name === 'GB'; });
                var exactPostcode = components.some(function (part) { return part.types.indexOf('postal_code') !== -1 && part.long_name.replace(/\s/g, '').toUpperCase() === postcode.replace(/\s/g, '').toUpperCase(); });
                var countryOnly = candidate.types && candidate.types.indexOf('country') !== -1;
                return (!ukOnly || (inUK && !countryOnly && !candidate.partial_match)) && (!ukOnly || !completePostcode || exactPostcode);
            });
            if (status !== google.maps.GeocoderStatus.OK || !result) {
                searchState('We couldn’t find that location. Check the spelling or try a nearby town or postcode.', false, true);
                return;
            }

            var location = result.geometry.location;
            cmapMatchedLocation = result.formatted_address;
            var point = new OpenLayers.LonLat(location.lng(), location.lat()).transform(
                new OpenLayers.Projection("EPSG:4326"),
                new OpenLayers.Projection("EPSG:3857")
            );

            postcodeDrawBox(point);
            if (!window.CMAP_REFERENCE_ONLY) redrawBoxToMap2();

            var mapElement = document.getElementById("map2");
            if (mapElement && mapElement.style.display !== "none" && typeof range !== "undefined") range.disabled = false;

            isBoxShowed = cmapHubDimensions ? Boolean(currentBounds) : true;
            changeprice();
            cmapPostcodeConfirmed = postcode;
            searchState('Location found: ' + result.formatted_address + '. You can select your map area below.', false, false);
            cmapRefreshLocationMessage();
            document.dispatchEvent(new CustomEvent('cmap:location-selection', { detail: { confirmed: postcodeField.value.trim() === postcode } }));
        });
    }
    if (immediate === true) findLocation();
    else cmapPostcodeSearchTimer = setTimeout(findLocation, 350);
}
function redrawBoxToMap2() {
    const _0x46cad3 = _0x37a427,
        _0x1a76f9 = transform[_0x46cad3(0x13d)][_0x46cad3(0x106)]["bounds"];
    if (_0x1a76f9) {
        box2[_0x46cad3(0x185)](), transform2["deactivate"](), vectors2["destroyFeatures"]();
        const _0x131ffc = new OpenLayers[_0x46cad3(0x163)](_0x1a76f9[_0x46cad3(0x10d)], _0x1a76f9[_0x46cad3(0x132)])[_0x46cad3(0xf2)](new OpenLayers[_0x46cad3(0x127)](_0x46cad3(0xfe)), new OpenLayers[_0x46cad3(0x127)](_0x46cad3(0xf4))),
            _0x381bfd = new OpenLayers["LonLat"](_0x1a76f9["right"], _0x1a76f9["top"])[_0x46cad3(0xf2)](new OpenLayers[_0x46cad3(0x127)](_0x46cad3(0xfe)), new OpenLayers[_0x46cad3(0x127)](_0x46cad3(0xf4))),
            _0xe61690 = new OpenLayers[_0x46cad3(0x11f)]();
        _0xe61690[_0x46cad3(0x1aa)](_0x131ffc), _0xe61690[_0x46cad3(0x1aa)](_0x381bfd), centerTwoMaps();
        const _0x45764a = new OpenLayers["Feature"]["Vector"](_0xe61690["toGeometry"]());
        vectors2[_0x46cad3(0x194)](_0x45764a), transform2[_0x46cad3(0x117)](_0x45764a), transform2[_0x46cad3(0x192)](), box2[_0x46cad3(0x192)]();
    }
}
function postcodeDrawBox(_0x416f27) {
    if (cmapHubDimensions) {
        osMap.setCenter(_0x416f27, postCodeStartZoom);
        cmapUpdateDimensionCrop(true);
        return;
    }
    const _0x35e7ce = _0x37a427,
        _0x3659ff = document[_0x35e7ce(0x118)]("inpWi"),
        _0xd5eeea = document[_0x35e7ce(0x118)](_0x35e7ce(0x1b3));
    let _0x2ae02f, _0x1e54f3;
    if (!_0x3659ff[_0x35e7ce(0x11d)] || !_0xd5eeea[_0x35e7ce(0x11d)] || !transform["box"][_0x35e7ce(0x106)][_0x35e7ce(0x170)])
        _0x3659ff[_0x35e7ce(0x11d)] && _0xd5eeea[_0x35e7ce(0x11d)]
            ? ((_0x2ae02f = Math[_0x35e7ce(0x17e)](_0x3659ff[_0x35e7ce(0x11d)] / ratioWidth)), (_0x1e54f3 = Math[_0x35e7ce(0x17e)](_0xd5eeea[_0x35e7ce(0x11d)] / ratioHeight)))
            : ((_0x2ae02f = BOX_WIDTH), (_0x1e54f3 = BOX_HEIGHT), (_0x3659ff[_0x35e7ce(0x11d)] = lastWidth), (_0xd5eeea[_0x35e7ce(0x11d)] = lastHeight));
    else {
        (lastWidth = _0x3659ff[_0x35e7ce(0x11d)]), (lastHeight = _0xd5eeea[_0x35e7ce(0x11d)]);
        const _0x52c1e = transform[_0x35e7ce(0x13d)][_0x35e7ce(0x106)][_0x35e7ce(0x170)];
        (_0x2ae02f = (_0x52c1e[_0x35e7ce(0x10d)] - _0x52c1e[_0x35e7ce(0x11e)]) / 0x2), (_0x1e54f3 = (_0x52c1e[_0x35e7ce(0x148)] - _0x52c1e[_0x35e7ce(0x132)]) / 0x2);
    }
    osMap[_0x35e7ce(0x1af)](new OpenLayers[_0x35e7ce(0x163)](_0x416f27[_0x35e7ce(0xf9)], _0x416f27["lat"]), postCodeStartZoom);
    const _0x2a43b7 = new OpenLayers[_0x35e7ce(0x11f)](_0x416f27[_0x35e7ce(0xf9)] - _0x2ae02f, _0x416f27["lat"] + _0x1e54f3, _0x416f27["lon"] + _0x2ae02f, _0x416f27[_0x35e7ce(0x1a6)] - _0x1e54f3);
    drawBoxBounds(_0x2a43b7);
}
function boxTransformEvent(_0x360194) {
    const _0x559329 = _0x37a427,
        _0x16ee81 = document["getElementById"](_0x559329(0x140)),
        _0x1ea144 = document[_0x559329(0x118)](_0x559329(0x1b3)),
        _0x53b819 = _0x360194["feature"][_0x559329(0x106)][_0x559329(0x170)],
        _0x5c436b = (_0x53b819[_0x559329(0x11e)] - _0x53b819[_0x559329(0x10d)]) / 0x2,
        _0x4db1a6 = (_0x53b819["top"] - _0x53b819[_0x559329(0x132)]) / 0x2;
    (ratioWidth = _0x16ee81[_0x559329(0x11d)] / _0x5c436b), (ratioHeight = _0x1ea144["value"] / _0x4db1a6), drawBoxBounds(_0x53b819);
}
function doBoxCalculations(_0x107440) {
    calculateScaleExtents(_0x107440), setRectDescription(_0x107440), calculatePrice();
}
function setRectDescription(_0x1dd33) {
    const _0x2332ed = _0x37a427,
        _0xdd4f0 = new OpenLayers[_0x2332ed(0x163)](_0x1dd33["left"], _0x1dd33[_0x2332ed(0x132)])[_0x2332ed(0xf2)](new OpenLayers[_0x2332ed(0x127)](_0x2332ed(0xfe)), new OpenLayers[_0x2332ed(0x127)]("EPSG:4326")),
        _0x5db955 = new OpenLayers[_0x2332ed(0x163)](_0x1dd33["right"], _0x1dd33[_0x2332ed(0x148)])[_0x2332ed(0xf2)](new OpenLayers[_0x2332ed(0x127)]("EPSG:3857"), new OpenLayers["Projection"]("EPSG:4326"));
    _0xdd4f0[_0x2332ed(0xf9)] < _0x5db955[_0x2332ed(0xf9)]
        ? (document[_0x2332ed(0x118)](_0x2332ed(0x19b))[_0x2332ed(0x11d)] =
              _0x2332ed(0x15a) + _0xdd4f0[_0x2332ed(0x1a6)] + ",\x20" + _0xdd4f0[_0x2332ed(0xf9)] + _0x2332ed(0x130) + _0x5db955[_0x2332ed(0x1a6)] + ",\x20" + _0x5db955[_0x2332ed(0xf9)] + _0x2332ed(0x1b1))
        : (document[_0x2332ed(0x118)](_0x2332ed(0x19b))["value"] = _0x2332ed(0x15a) + _0x5db955[_0x2332ed(0x1a6)] + ",\x20" + _0x5db955[_0x2332ed(0xf9)] + "),(" + _0xdd4f0["lat"] + ",\x20" + _0xdd4f0["lon"] + _0x2332ed(0x1b1));
}
function _0x2d1b(_0x14342b, _0x142101) {
    const _0x5610d2 = _0x5610();
    return (
        (_0x2d1b = function (_0x2d1b7c, _0x4f4bc7) {
            _0x2d1b7c = _0x2d1b7c - 0xef;
            let _0x3446e2 = _0x5610d2[_0x2d1b7c];
            return _0x3446e2;
        }),
        _0x2d1b(_0x14342b, _0x142101)
    );
}
function fChkChange(){const a=_0x37a427,b=document[a(0x118)](a(0x140)),c=document.getElementById(a(0x1b3));if(b[a(0x11d)]!==""&&c[a(0x11d)]!==""){let d=b[a(0x11d)],e=c[a(0x11d)];const f=document.getElementById("c-width-unit-wmap")||document.getElementById("c-width-unit-cmap");f&&f.value==="in"&&(d=parseFloat(d)*2.54,e=parseFloat(e)*2.54),resizeRectangle(parseFloat(d),parseFloat(e)),setMainMap()}}

// The hub can show a location without implying a customer wall size.
function cmapUpdateDimensionCrop(recentre) {
    if (!osMap || !transform || !vectors) return;
    var dimensions = cmapMatchedLocation && typeof cmapGetMapDimensions === 'function' ? cmapGetMapDimensions() : null;
    if (!dimensions) {
        var frame = document.getElementById('cmap-fixed-crop');
        if (frame) frame.hidden = true;
        transform.unsetFeature();
        vectors.destroyFeatures();
        currentBounds = null;
        lastWidth = lastHeight = null;
        ratioWidth = ratioHeight = 0;
        isBoxShowed = false;
        document.getElementById('inpFrmIN').value = '';
        $('#scale_extents').hide();
        cmapRefreshLocationMessage();
        return;
    }
    var size = osMap.getSize();
    if (!size || !size.w || !size.h) return;
    var frameWidth = Math.min(size.w * .72, size.h * .72 * dimensions.widthCm / dimensions.heightCm);
    var frameHeight = frameWidth * dimensions.heightCm / dimensions.widthCm;
    var frame = document.getElementById('cmap-fixed-crop');
    if (!frame) {
        frame = document.createElement('div');
        frame.id = 'cmap-fixed-crop';
        frame.className = 'cmap-fixed-crop';
        frame.setAttribute('aria-hidden', 'true');
        ['width', 'height'].forEach(function (axis) {
            var label = document.createElement('span');
            label.className = 'cmap-crop-dimension cmap-crop-dimension--' + axis;
            frame.appendChild(label);
        });
        osMap.div.appendChild(frame);
    }
    frame.querySelector('.cmap-crop-dimension--width').textContent = document.getElementById('inpWi').value + ' ' + dimensions.widthUnit;
    frame.querySelector('.cmap-crop-dimension--height').textContent = document.getElementById('inpHe').value + ' ' + dimensions.heightUnit;
    frame.hidden = false;
    frame.style.width = frameWidth + 'px';
    frame.style.height = frameHeight + 'px';
    var bottomLeft = osMap.getLonLatFromViewPortPx(new OpenLayers.Pixel((size.w - frameWidth) / 2, (size.h + frameHeight) / 2));
    var topRight = osMap.getLonLatFromViewPortPx(new OpenLayers.Pixel((size.w + frameWidth) / 2, (size.h - frameHeight) / 2));
    var bounds = new OpenLayers.Bounds(bottomLeft.lon, bottomLeft.lat, topRight.lon, topRight.lat);
    lastWidth = dimensions.widthCm;
    lastHeight = dimensions.heightCm;
    ratioWidth = lastWidth / (bounds.getWidth() / 2);
    ratioHeight = lastHeight / (bounds.getHeight() / 2);
    transform.deactivate();
    vectors.destroyFeatures();
    currentBounds = bounds;
    doBoxCalculations(bounds);
    isBoxShowed = true;
    $('#scale_extents').show();
    cmapRefreshLocationMessage();
}

function resizeRectangle(_0x3ccaaa, _0x2a6a4a) {
    if (cmapHubDimensions) {
        cmapUpdateDimensionCrop(false);
        return;
    }
    const _0x14b3fb = _0x37a427,
        _0x5bc27c = _0x3ccaaa / ratioWidth,
        _0x3652af = _0x2a6a4a / ratioHeight,
        _0x358efe = transform["center"]["x"],
        _0x1cd6c5 = transform[_0x14b3fb(0x10f)]["y"],
        _0x4e8412 = new OpenLayers[_0x14b3fb(0x11f)](_0x358efe - _0x5bc27c, _0x1cd6c5 + _0x3652af, _0x358efe + _0x5bc27c, _0x1cd6c5 - _0x3652af);
    drawBoxBounds(_0x4e8412);
}
function rangeBoxResize(_0x5af5b8) {
    const _0x3ce1ed = _0x37a427;
    if (catchBounds) {
        let _0x32a9dd = (catchBounds[_0x3ce1ed(0x10d)] - catchBounds["right"]) / METRES_IN_KM,
            _0x4c8dec = (catchBounds[_0x3ce1ed(0x148)] - catchBounds[_0x3ce1ed(0x132)]) / METRES_IN_KM;
        (_0x32a9dd = _0x32a9dd * _0x5af5b8), (_0x4c8dec = _0x4c8dec * _0x5af5b8);
        const _0x405a33 = new OpenLayers["Bounds"](catchBounds["left"] + _0x32a9dd, catchBounds[_0x3ce1ed(0x132)] - _0x4c8dec, catchBounds["right"] - _0x32a9dd, catchBounds[_0x3ce1ed(0x148)] + _0x4c8dec);
        drawBoxBounds(_0x405a33);
    }
}
function constrainReferenceBounds(_0x4e9ad3) {
    if (!window.CMAP_REFERENCE_ONLY || !osMap || !currentBounds) return _0x4e9ad3;
    var _0x1de860 = osMap.calculateBounds();
    if (!_0x1de860) return _0x4e9ad3;

    if (cmapHubDimensions) {
        var dimensions = cmapGetMapDimensions();
        if (!dimensions) return _0x4e9ad3;
        var width = Math.abs(_0x4e9ad3.getWidth());
        var height = width * dimensions.heightCm / dimensions.widthCm;
        var scale = Math.min(1, _0x1de860.getWidth() / width, _0x1de860.getHeight() / height);
        width *= scale;
        height *= scale;
        var centre = _0x4e9ad3.getCenterLonLat();
        var x = Math.max(_0x1de860.left + width / 2, Math.min(centre.lon, _0x1de860.right - width / 2));
        var y = Math.max(_0x1de860.bottom + height / 2, Math.min(centre.lat, _0x1de860.top - height / 2));
        return new OpenLayers.Bounds(x - width / 2, y - height / 2, x + width / 2, y + height / 2);
    }

    var _0x407d8e = Math.max(_0x4e9ad3.left, _0x1de860.left),
        _0x1c8a22 = Math.max(_0x4e9ad3.bottom, _0x1de860.bottom),
        _0x42f09d = Math.min(_0x4e9ad3.right, _0x1de860.right),
        _0x269b10 = Math.min(_0x4e9ad3.top, _0x1de860.top);

    if (_0x42f09d <= _0x407d8e || _0x269b10 <= _0x1c8a22) return currentBounds;
    return new OpenLayers.Bounds(_0x407d8e, _0x1c8a22, _0x42f09d, _0x269b10);
}
function drawBoxBounds(_0x38ba64, dimensionsChanged) {
    const _0x5024fb = _0x37a427,
        _0x2e4900 = checkScaleExtents(_0x38ba64);
    _0x2e4900 !== null && (_0x38ba64 = _0x2e4900);
    if (cmapHubDimensions) {
        _0x38ba64 = new OpenLayers.Bounds(Math.min(_0x38ba64.left, _0x38ba64.right), Math.min(_0x38ba64.bottom, _0x38ba64.top), Math.max(_0x38ba64.left, _0x38ba64.right), Math.max(_0x38ba64.bottom, _0x38ba64.top));
    }
    if (!dimensionsChanged) _0x38ba64 = constrainReferenceBounds(_0x38ba64);
    openLayersBox[_0x5024fb(0x185)](), transform["unsetFeature"](), vectors[_0x5024fb(0x10a)]();
    const _0x31bb98 = new OpenLayers["Feature"]["Vector"](_0x38ba64[_0x5024fb(0x14a)]());
    vectors[_0x5024fb(0x194)](_0x31bb98), transform[_0x5024fb(0x117)](_0x31bb98), doBoxCalculations(_0x38ba64), openLayersBox["deactivate"](), (currentBounds = _0x38ba64);
}
function onlyNumber(_0x518de7) {
    const _0x30b2fa = _0x37a427;
    var _0x1cda0b = _0x518de7 || window["event"],
        _0x264f9c = _0x1cda0b["keyCode"] || _0x1cda0b[_0x30b2fa(0x1a1)];
    _0x264f9c = String[_0x30b2fa(0x196)](_0x264f9c);
    var _0x2fcdce = /[0-9]|\./;
    if (!_0x2fcdce[_0x30b2fa(0x128)](_0x264f9c)) {
        _0x1cda0b[_0x30b2fa(0x100)] = ![];
        if (_0x1cda0b[_0x30b2fa(0x1b8)]) _0x1cda0b[_0x30b2fa(0x1b8)]();
    }
}
function getSmoothsPrice() {
    const _0x104979 = _0x37a427,
        _0x3eb919 = document[_0x104979(0x118)](_0x104979(0x19e));
    return smooths[_0x104979(0x18d)](_0x3eb919[_0x104979(0x11d)]) ? smooths[_0x3eb919["value"]][_0x104979(0x15d)] : 0x0;
}
function priceCalc() {
    const _0x52cef6 = _0x37a427,
        _0x3d455d = document[_0x52cef6(0x118)](_0x52cef6(0x140)),
        _0x30386d = document[_0x52cef6(0x118)](_0x52cef6(0x1b3));
    if (_0x3d455d["value"] !== "" && _0x30386d["value"] !== "" && transform[_0x52cef6(0x13d)][_0x52cef6(0x106)][_0x52cef6(0x170)]) {
        var _0x1bb8e5 = transform[_0x52cef6(0x13d)][_0x52cef6(0x106)][_0x52cef6(0x170)],
            _0x24a126 = new OpenLayers[_0x52cef6(0x163)](_0x1bb8e5["left"], _0x1bb8e5[_0x52cef6(0x132)])[_0x52cef6(0xf2)](new OpenLayers[_0x52cef6(0x127)](_0x52cef6(0xfe)), new OpenLayers[_0x52cef6(0x127)](_0x52cef6(0x1b6))),
            _0x5b3a73 = new OpenLayers[_0x52cef6(0x163)](_0x1bb8e5[_0x52cef6(0x11e)], _0x1bb8e5["top"])[_0x52cef6(0xf2)](new OpenLayers[_0x52cef6(0x127)](_0x52cef6(0xfe)), new OpenLayers[_0x52cef6(0x127)]("EPSG:4326")),
            _0x108cb1 = new google["maps"]["LatLng"](_0x24a126["lat"], _0x24a126["lon"]),
            _0x1945eb = new google[_0x52cef6(0x152)]["LatLng"](_0x5b3a73[_0x52cef6(0x1a6)], _0x5b3a73[_0x52cef6(0xf9)]),
            _0x24a357 = new google[_0x52cef6(0x152)][_0x52cef6(0x151)](_0x24a126[_0x52cef6(0x1a6)], _0x5b3a73["lon"]),
            _0x42d94c = new google[_0x52cef6(0x152)][_0x52cef6(0x151)](_0x5b3a73[_0x52cef6(0x1a6)], _0x24a126[_0x52cef6(0xf9)]);
        Area = google[_0x52cef6(0x152)][_0x52cef6(0x106)]["spherical"][_0x52cef6(0x181)]([_0x1945eb, _0x42d94c, _0x108cb1, _0x24a357]) / 0xf4240;
        var _0x4706c3 = (parseInt(_0x3d455d[_0x52cef6(0x11d)]) + muralAdditionSize) * (parseInt(_0x30386d[_0x52cef6(0x11d)]) + muralAdditionSize),
            _0x48637f = fixSetUp + _0x4706c3 * getSmoothsPrice(),
            _0x35911c = document[_0x52cef6(0x118)](_0x52cef6(0x124)),
            _0x2de658 = _0x35911c[_0x52cef6(0x11d)],
            _0x3afadf = 0x0;
        if (_0x2de658 === "10") _0x3afadf = Area * 0.8;
        else {
            if (_0x2de658 === "D25") {
            } else {
                if (_0x2de658 === _0x52cef6(0x12f)) _0x3afadf = Area * 0.06;
                else _0x2de658 === "50" && (_0x3afadf = Area * 0.03);
            }
        }
        return (_0x3afadf = parseFloat(_0x3afadf[_0x52cef6(0x182)](0x2))), (Area = parseFloat(Area[_0x52cef6(0x182)](0x2))), (_0x48637f += _0x3afadf), (_0x48637f = parseFloat(_0x48637f["toFixed"](0x2))), _0x48637f;
    }
}
function PriceShowCalc() {
    if (typeof window.cmapGetMapPricing === "function") {
        var pricing = window.cmapGetMapPricing();
        if (pricing) return pricing.totalPrice;
    }
    Price = priceCalc();
    const _0xfe7d53 = Price + (Price * useVAT) / 0x64;
    return _0xfe7d53;
}
function calculatePrice() {
    if (typeof window.cmapUpdateMapPrice === "function") {
        var mapPricing = window.cmapUpdateMapPrice();
        if (mapPricing) {
            Price = mapPricing.totalPrice / (1 + useVAT / 100);
            calcPrice = Price;
            return Price;
        }
    }
    const _0x402910 = _0x37a427;
    Price = priceCalc();
    if (Price !== undefined) {
        let _0x9e0c60 = Price + (Price * useVAT) / 0x64;
        sendProof && ((Price = proofsOnlyPrice), (_0x9e0c60 = proofsOnlyPrice + (proofsOnlyPrice * useVAT) / 0x64)),
            (document[_0x402910(0x118)](_0x402910(0x180))[_0x402910(0x11d)] = formatCurrency(_0x9e0c60)),
            (calcPrice = Price);
    }
    return Price;
}
function toRestrictedBox(_0x55a6ab, _0x4aac20) {
    const _0x416504 = _0x37a427,
        _0x43a016 = document[_0x416504(0x118)]("inpWi")["value"],
        _0x35f6f6 = document[_0x416504(0x118)](_0x416504(0x1b3))["value"],
        _0x4c6d6f = ((_0x55a6ab * _0x43a016) / 0x186a0) * METRES_IN_KM,
        _0x465011 = ((_0x55a6ab * _0x35f6f6) / 0x186a0) * METRES_IN_KM,
        _0x5a7019 = _0x4c6d6f / EPSG_3857_POINT_SCALE_FACTOR,
        _0x1c82d4 = _0x465011 / EPSG_3857_POINT_SCALE_FACTOR,
        _0x474e1b = _0x4aac20[_0x416504(0x10d)] + (_0x4aac20["right"] - _0x4aac20[_0x416504(0x10d)]) / 0x2,
        _0x5353ff = _0x4aac20[_0x416504(0x132)] + (_0x4aac20[_0x416504(0x148)] - _0x4aac20[_0x416504(0x132)]) / 0x2;
    return new OpenLayers[_0x416504(0x11f)](_0x474e1b - _0x5a7019, _0x5353ff + _0x1c82d4, _0x474e1b + _0x5a7019, _0x5353ff - _0x1c82d4);
}
function checkScaleExtents(_0x3cd59f) {
    const [, , _0x1e0fd6] = getScaleInfoValues(_0x3cd59f);
    // The bespoke hub is a design brief: allow customers to indicate a much
    // smaller local area, then let the studio validate the final artwork.
    // Keep the legacy map-tool restriction everywhere else.
    const _0x4af0a0 = window.CMAP_REFERENCE_ONLY ? 500 : BOX_SCALE_MIN_LIMIT;
    if (_0x1e0fd6 > BOX_SCALE_MAX_LIMIT) return toRestrictedBox(BOX_SCALE_MAX_LIMIT, _0x3cd59f);
    if (_0x1e0fd6 < _0x4af0a0) return toRestrictedBox(_0x4af0a0, _0x3cd59f);
    return null;
}
function calculateScaleExtents(_0x43f65f) {
    const _0x340ce7 = _0x37a427,
        [_0x55701c, _0x6b5246, _0x750e00] = getScaleInfoValues(_0x43f65f);
    return (
        (document[_0x340ce7(0x118)](_0x340ce7(0xff))[_0x340ce7(0x107)] = _0x340ce7(0x1ac) + _0x750e00),
        (document["getElementById"](_0x340ce7(0x13e))[_0x340ce7(0x107)] =
            _0x340ce7(0x161) + _0x55701c + "\x20km\x20(" + numberFormat(_0x55701c * 0.621371) + _0x340ce7(0x15e) + _0x6b5246 + _0x340ce7(0x139) + numberFormat(_0x6b5246 * 0.621371) + _0x340ce7(0x116)),
        null
    );
}
function getScaleInfoValues(_0x2da4ef) {
    const _0x53ce99 = _0x37a427,
        _0x2877f2 = numberFormat(((Math[_0x53ce99(0x14d)](_0x2da4ef[_0x53ce99(0x11e)] - _0x2da4ef["left"]) / 0x2) * EPSG_3857_POINT_SCALE_FACTOR) / METRES_IN_KM),
        _0x3ca8ad = numberFormat(((Math["abs"](_0x2da4ef["top"] - _0x2da4ef[_0x53ce99(0x132)]) / 0x2) * EPSG_3857_POINT_SCALE_FACTOR) / METRES_IN_KM),
        _0x1d42e4 = document[_0x53ce99(0x118)]("inpHe")[_0x53ce99(0x11d)],
        _0x49013f = Math[_0x53ce99(0x17e)]((_0x3ca8ad * 0x186a0) / _0x1d42e4);
    return [_0x2877f2, _0x3ca8ad, _0x49013f];
}
function sendOrder() {
    const _0x5b1808 = _0x37a427;
    var _0x323f59 = document[_0x5b1808(0x118)](_0x5b1808(0x19b)),
        _0xe63526 = document[_0x5b1808(0x118)](_0x5b1808(0x150)),
        _0x757db7 = document[_0x5b1808(0x118)](_0x5b1808(0x15f)),
        _0x3cee7e = document[_0x5b1808(0x118)]("inpFrmQu"),
        _0x4c6113 = document[_0x5b1808(0x118)]("inpFrmSh"),
        _0xe4b392 = document[_0x5b1808(0x118)](_0x5b1808(0x124)),
        _0x51096f = transform["box"][_0x5b1808(0x106)][_0x5b1808(0x170)],
        _0x451679 = new OpenLayers[_0x5b1808(0x163)](_0x51096f[_0x5b1808(0x10d)], _0x51096f[_0x5b1808(0x132)])[_0x5b1808(0xf2)](new OpenLayers["Projection"]("EPSG:3857"), new OpenLayers[_0x5b1808(0x127)](_0x5b1808(0x1b6))),
        _0x2d6783 = new OpenLayers["LonLat"](_0x51096f[_0x5b1808(0x11e)], _0x51096f[_0x5b1808(0x148)])[_0x5b1808(0xf2)](new OpenLayers[_0x5b1808(0x127)](_0x5b1808(0xfe)), new OpenLayers["Projection"](_0x5b1808(0x1b6))),
        _0x40b615 =
            "((" +
            _0x451679[_0x5b1808(0x1a6)][_0x5b1808(0x182)](fractionDigits) +
            ",\x20" +
            _0x451679[_0x5b1808(0xf9)][_0x5b1808(0x182)](fractionDigits) +
            _0x5b1808(0x130) +
            _0x2d6783[_0x5b1808(0x1a6)][_0x5b1808(0x182)](fractionDigits) +
            ",\x20" +
            _0x2d6783["lon"]["toFixed"](fractionDigits) +
            "))",
        _0x222303 = parseInt(document[_0x5b1808(0x118)](_0x5b1808(0x140))[_0x5b1808(0x11d)]) + muralAdditionSize,
        _0x38d6e5 = parseInt(document[_0x5b1808(0x118)](_0x5b1808(0x1b3))[_0x5b1808(0x11d)]) + muralAdditionSize,
        _0x288c10 = title;
    (_0x288c10 = _0x288c10[_0x5b1808(0x1a8)](_0x5b1808(0x199), document["getElementById"](_0x5b1808(0x19e))[_0x5b1808(0x11d)])),
        (_0x288c10 = _0x288c10[_0x5b1808(0x1a8)](_0x5b1808(0xf5), document["getElementById"](_0x5b1808(0x193))["value"])),
        (_0x288c10 = _0x288c10["replace"]("{mapType}", _0xe4b392[_0x5b1808(0x1ba)][_0xe4b392[_0x5b1808(0x16f)]][_0x5b1808(0x107)])),
        (_0x288c10 = _0x288c10["replace"](_0x5b1808(0x172), _0x222303 - muralAdditionSize)),
        (_0x288c10 = _0x288c10["replace"](_0x5b1808(0xfd), _0x38d6e5 - muralAdditionSize)),
        (_0x288c10 = _0x288c10[_0x5b1808(0x1a8)]("{widthMural}", _0x222303)),
        (_0x288c10 = _0x288c10["replace"](_0x5b1808(0x191), _0x38d6e5)),
        (_0x288c10 = _0x288c10[_0x5b1808(0x1a8)](_0x5b1808(0x19f), Area)),
        (_0x288c10 = _0x288c10[_0x5b1808(0x1a8)](_0x5b1808(0x17c), _0x40b615));
    let _0x20e1a0 = _0x288c10;
    if (sendProof) {
        let _0x466f6a = proofsTitle;
        (_0x466f6a = _0x466f6a[_0x5b1808(0x1a8)](_0x5b1808(0xf6), _0x20e1a0)),
            (_0x466f6a = _0x466f6a["replace"](_0x5b1808(0x103), formatCurrency(PriceShowCalc()))),
            (_0x20e1a0 = _0x466f6a),
            (document["getElementById"](_0x5b1808(0x113))[_0x5b1808(0x11d)] = "0");
    } else document[_0x5b1808(0x118)](_0x5b1808(0x113))[_0x5b1808(0x11d)] = "0";
    (_0x323f59[_0x5b1808(0x11d)] = _0x20e1a0), (_0xe63526[_0x5b1808(0x11d)] = calculatePrice()), (_0x3cee7e[_0x5b1808(0x11d)] = "1"), document[_0x5b1808(0x118)]("frmOrderMap")["submit"]();
}
function fChgProof(_0x409514) {
    const _0x3c3d94 = _0x37a427;
    (sendProof = !!_0x409514[_0x3c3d94(0x165)]), calculatePrice();
}
function parseQuery(_0x155423) {
    const _0x1b9a60 = _0x37a427,
        _0x48443c = {},
        _0x5639b3 = _0x155423[_0x1b9a60(0x195)](0x1)[_0x1b9a60(0xfa)]("&");
    for (var _0x1a9aaf = 0x0; _0x1a9aaf < _0x5639b3["length"]; _0x1a9aaf++) {
        var _0x55a483 = _0x5639b3[_0x1a9aaf][_0x1b9a60(0xfa)]("=");
        _0x48443c[decodeURIComponent(_0x55a483[0x0])] = decodeURIComponent(_0x55a483[0x1] || "");
    }
    return _0x48443c;
}
function init() {
    const _0x515e9f = _0x37a427,
        _0x3c16e0 = new OpenLayers[_0x515e9f(0x127)](_0x515e9f(0x1b6)),
        _0x2211ab = new OpenLayers[_0x515e9f(0x127)](_0x515e9f(0xfe)),
        _0x3401d7 = { units: "m", allOverlays: !![], projection: new OpenLayers[_0x515e9f(0x127)]("EPSG:3857"), displayProjection: new OpenLayers["Projection"](_0x515e9f(0x1b6)) };
    osMap = new OpenLayers[_0x515e9f(0x10e)](_0x515e9f(0x1a3), _0x3401d7);
    const _0x453ea9 = new OpenLayers[_0x515e9f(0x167)][_0x515e9f(0x12d)](_0x515e9f(0x145), { numZoomLevels: 0x14, visibility: !![] }),
        _0x11f92c = new OpenLayers[_0x515e9f(0x167)][_0x515e9f(0x12d)](_0x515e9f(0x168), { type: google[_0x515e9f(0x152)][_0x515e9f(0x14e)][_0x515e9f(0x18a)], numZoomLevels: 0x14, visibility: ![] });
    osMap[_0x515e9f(0x188)]([_0x453ea9, _0x11f92c]), (vlayer = new OpenLayers[_0x515e9f(0x167)]["Vector"](_0x515e9f(0x189))), osMap["addLayer"](vlayer);
    var _0x23b61a = new OpenLayers[_0x515e9f(0x14f)]["Panel"]({
        displayClass: "olControlEditingToolbar",
        createControlMarkup: function (_0x201c89) {
            const _0x571099 = _0x515e9f;
            var _0x5d15ad = document[_0x571099(0xfc)]("button"),
                _0x261db1 = document[_0x571099(0xfc)]("span"),
                _0x22d588 = document[_0x571099(0xfc)]("span");
            _0x5d15ad["setAttribute"]("class", "controlButtons" + _0x201c89["id"]), _0x5d15ad["setAttribute"]("id", _0x571099(0x173) + _0x201c89["id"]), (_0x261db1[_0x571099(0x107)] = "&nbsp;"), _0x5d15ad["appendChild"](_0x261db1);
            _0x201c89[_0x571099(0x1a7)] && (_0x22d588["innerHTML"] = _0x201c89[_0x571099(0x1a7)]);
            _0x5d15ad["appendChild"](_0x22d588);
            if (_0x201c89["id"] === 0x2) _0x5d15ad[_0x571099(0x16a)]["add"](_0x571099(0x108));
            const _0x270669 = function () {
                const _0x34c8f6 = _0x571099;
                if (_0x201c89["id"] === 0x2)
                    _0x453ea9["setVisibility"](!![]),
                        _0x11f92c[_0x34c8f6(0x153)](![]),
                        document["getElementById"](_0x34c8f6(0xf0))[_0x34c8f6(0x16a)]["remove"](_0x34c8f6(0x108)),
                        document[_0x34c8f6(0x118)]("controlButtons2")[_0x34c8f6(0x16a)][_0x34c8f6(0x1a4)]("active");
                else
                    _0x201c89["id"] === 0x1 &&
                        (_0x453ea9[_0x34c8f6(0x153)](![]),
                        _0x11f92c["setVisibility"](!![]),
                        document[_0x34c8f6(0x118)](_0x34c8f6(0xf0))[_0x34c8f6(0x16a)][_0x34c8f6(0x1a4)](_0x34c8f6(0x108)),
                        document["getElementById"]("controlButtons2")[_0x34c8f6(0x16a)][_0x34c8f6(0xf3)](_0x34c8f6(0x108)));
            };
            return "ontouchstart" in document[_0x571099(0x1ad)] ? _0x5d15ad[_0x571099(0x169)](_0x571099(0x115), _0x270669) : _0x5d15ad[_0x571099(0x169)](_0x571099(0x176), _0x270669), _0x5d15ad;
        },
    });
    const _0x2d2c95 = new OpenLayers[_0x515e9f(0x14f)][_0x515e9f(0x166)](vlayer, { title: _0x515e9f(0x16e), text: _0x515e9f(0x160), id: 0x1 }),
        _0x42acee = new OpenLayers[_0x515e9f(0x14f)][_0x515e9f(0x166)](vlayer, { title: "Show\x20Map", text: _0x515e9f(0x10e), id: 0x2 });
    _0x23b61a["addControls"]([_0x2d2c95, _0x42acee]),
        osMap[_0x515e9f(0x18e)](_0x23b61a),
        osMap["events"][_0x515e9f(0x11b)](_0x515e9f(0x14b), osMap, function () {
            const _0x1a37ad = _0x515e9f;
            zoom = osMap[_0x1a37ad(0x122)]();
            if (osMap[_0x1a37ad(0x10b)] < 0x7) {
                if (cmapHubDimensions) {
                    osMap.setCenter(osMap.getCenter(), 7);
                    return;
                }
                var _0x1bf44e = transform[_0x1a37ad(0x10f)],
                    _0x480c82,
                    _0x33c58d;
                _0x1bf44e["x"] ? ((_0x480c82 = _0x1bf44e["x"]), (_0x33c58d = _0x1bf44e["y"])) : ((_0x480c82 = osMap[_0x1a37ad(0x10f)][_0x1a37ad(0xf9)]), (_0x33c58d = osMap[_0x1a37ad(0x10f)]["lat"])),
                    osMap[_0x1a37ad(0x1af)](new OpenLayers["LonLat"](_0x480c82, _0x33c58d), 0x7);
            }
        });
    const _0x540d9e = new OpenLayers[_0x515e9f(0x146)](window.CMAP_REFERENCE_ONLY ? { fillColor: "#E8F0E6", fillOpacity: 0.28, strokeColor: "#263B2F", strokeWidth: 0x2, cursor: _0x515e9f(0x131), pointRadius: 0x5 } : { fillColor: _0x515e9f(0x1a9), fillOpacity: _0x515e9f(0x178), strokeWidth: 0x2, cursor: _0x515e9f(0x131), pointRadius: 0x5 });
    (vectors = new OpenLayers["Layer"]["Vector"](_0x515e9f(0x177), { displayInLayerSwitcher: ![], styleMap: _0x540d9e })),
        osMap[_0x515e9f(0x16b)](vectors),
        (openLayersBox = new OpenLayers["Control"][_0x515e9f(0x1b7)](vectors, OpenLayers[_0x515e9f(0x112)]["RegularPolygon"], { handlerOptions: { sides: 0x4, snapAngle: 0x5a, irregular: !![], persist: !![] } })),
        osMap["addControl"](openLayersBox),
        (transform = new OpenLayers[_0x515e9f(0x14f)][_0x515e9f(0x15c)](vectors, { rotate: ![], irregular: !![], preserveAspectRatio: !![] })),
        transform[_0x515e9f(0x13b)][_0x515e9f(0x11b)]("transformcomplete", transform, boxTransformEvent),
        transform[_0x515e9f(0x13b)][_0x515e9f(0x11b)]("transform", transform, function (_0x2ed2bb) {
            if (_0x2ed2bb.feature && _0x2ed2bb.feature.geometry && _0x2ed2bb.feature.geometry.bounds) calculateScaleExtents(_0x2ed2bb.feature.geometry.bounds);
        }),
        osMap[_0x515e9f(0x18e)](transform),
        osMap[_0x515e9f(0x18e)](openLayersBox),
        osMap[_0x515e9f(0x1af)](new OpenLayers[_0x515e9f(0x163)](setup_position[0x0], setup_position[0x1])[_0x515e9f(0xf2)](_0x3c16e0, _0x2211ab), 0x10),
        osMap["events"][_0x515e9f(0x11b)](_0x515e9f(0x1a2), osMap, function () {});
    if (cmapHubDimensions) {
        var updateCrop = function () { cmapUpdateDimensionCrop(false); };
        osMap.events.register('moveend', osMap, updateCrop);
        osMap.events.register('updatesize', osMap, updateCrop);
        if (window.ResizeObserver) {
            var resizeMap = new ResizeObserver(function () { osMap.updateSize(); updateCrop(); });
            resizeMap.observe(osMap.div);
        }
    }
}
function _0x5610() {
    const _0x13843d = [
        "\x20Wall\x20Area:\x20{widthWall}cm\x20x\x20{heightWall}cm,",
        ")))",
        "&key=dXRV6WaHrifE6JtzeX9DEv8tvfFZX9Dg",
        "inpHe",
        "shouldDraw",
        "tileCol",
        "EPSG:4326",
        "DrawFeature",
        "preventDefault",
        "load",
        "options",
        "\x20from\x20Postcode\x20{postCode}.",
        "controlButtons1",
        "push",
        "transform",
        "remove",
        "EPSG:27700",
        "{postCode}",
        "{title}",
        "style",
        "Proj4js",
        "lon",
        "split",
        "&style=true&format=",
        "createElement",
        "{heightWall}",
        "EPSG:3857",
        "scale",
        "returnValue",
        "height",
        "&tileMatrixSet=",
        "{orderPrice}",
        "url",
        "drawImage",
        "geometry",
        "innerHTML",
        "active",
        "range",
        "destroyFeatures",
        "zoom",
        "length",
        "left",
        "Map",
        "center",
        "change_map",
        "XYZ",
        "Handler",
        "inpFrmSh",
        "Size",
        "touchstart",
        "\x20mi)",
        "setFeature",
        "getElementById",
        "tileMatrix",
        "6053645hMGOTZ",
        "register",
        "RegularPolygon",
        "value",
        "right",
        "Bounds",
        "https://cdn.shopify.com/s/files/1/0892/7382/7668/files/loading.gif?v=1725849013",
        "indexOf",
        "getZoom",
        "defs",
        "selTM",
        "join",
        "\x20Total\x20of\x20{Area}\x20sq\x20km\x20from\x20",
        "Projection",
        "test",
        "1222632GNNbCp",
        "href",
        "CANVAS",
        "change",
        "Google",
        "EPSG:900913",
        "E25",
        "),(",
        "pointer",
        "bottom",
        "2591796jeDMUE",
        "toDataURL",
        "onload",
        "GeocoderStatus",
        "9240924DMFkMs",
        "Leisure",
        "\x20km\x20(",
        "map2",
        "events",
        "?service=WMTS&request=GetTile&version=1.0.0&layer=",
        "box",
        "extents",
        "&key=",
        "inpWi",
        "?service=WMTS&request=GetTile&version=1.0.0&layer=Road%2027700&style=true&format=image%2Fpng&tileMatrixSet=EPSG%3A27700&tileMatrix=EPSG%3A27700%3A${z}&tileRow=${y}&tileCol=${x}",
        "\x20Order\x20value\x20(Â£{orderPrice})",
        "tileMatrixSet",
        "target",
        "Google\x20Streets",
        "StyleMap",
        "Vector",
        "top",
        "975986YhvZuE",
        "toGeometry",
        "zoomend",
        "imgDiv",
        "abs",
        "MapTypeId",
        "Control",
        "inpFrmPr",
        "LatLng",
        "maps",
        "setVisibility",
        "none",
        "What\x20Would\x20My\x20OS\x20Map\x20Look\x20Like?",
        "+title=\x20Google\x20Mercator\x20EPSG:3857\x20+proj=merc\x20+a=6378137\x20+b=6378137\x20+lat_ts=0.0\x20+lon_0=0.0\x20+x_0=0.0\x20+y_0=0\x20+k=1.0\x20+units=m\x20+nadgrids=@null\x20+wktext\x20\x20+no_defs",
        "geocode",
        "data-id",
        "location",
        "(((",
        "&tileMatrix=",
        "TransformFeature",
        "price",
        "\x20mi)\x20x\x20",
        "inpFrmSI",
        "Satellite",
        "Map Coverage:\x20",
        "appendChild",
        "LonLat",
        "getContext",
        "checked",
        "SelectFeature",
        "Layer",
        "Google\x20Satellite",
        "addEventListener",
        "classList",
        "addLayer",
        "disabled",
        "Geocoder",
        "Show\x20Satellite",
        "selectedIndex",
        "bounds",
        "block",
        "{widthWall}",
        "controlButtons",
        "setAttribute",
        "+proj=merc\x20+a=6378137\x20+b=6378137\x20+lat_ts=0.0\x20+lon_0=0.0\x20+x_0=0.0\x20+y_0=0\x20+k=1.0\x20+units=m\x20+nadgrids=@null\x20+no_defs",
        "click",
        "Vector\x20Layer",
        "0.2",
        "#ccc",
        "key",
        "display",
        "{bounds}",
        "{mapType}\x20Map\x20Wallpaper\x20on\x20{smoothType},",
        "round",
        "search",
        "inpP",
        "computeArea",
        "toFixed",
        "width",
        "257089bcCMwv",
        "activate",
        "2114596LuXkUs",
        "layer",
        "addLayers",
        "Overlay",
        "SATELLITE",
        "select",
        "+proj=tmerc\x20+lat_0=49\x20+lon_0=-2\x20+k=0.9996012717\x20+x_0=400000\x20+y_0=-100000\x20+ellps=airy\x20+datum=OSGB36\x20+units=m\x20+no_defs",
        "hasOwnProperty",
        "addControl",
        "src",
        "crossOrigin",
        "{heightMural}",
        "deactivate",
        "inpPostCodChange",
        "addFeatures",
        "substr",
        "fromCharCode",
        "selected",
        "degrees",
        "{smoothType}",
        "https://api.os.uk/maps/raster/v1/wmts",
        "inpFrmIN",
        "tileRow",
        "Email\x20Proof\x20for\x20{title}",
        "smoothsSelect",
        "{Area}",
        "Anonymous",
        "which",
        "moveend",
        "map",
        "add",
        "136XuiToF",
        "lat",
        "text",
        "replace",
        "#ff0000",
        "extend",
        "getCenter",
        "Map Scale:\x201:",
        "documentElement",
        "pop",
        "setCenter",
    ];
    _0x5610 = function () {
        return _0x13843d;
    };
    return _0x5610();
}
function centerTwoMaps() {
    const _0xf8cf9d = _0x37a427,
        _0x24a1a5 = osMap["getCenter"]()["lon"],
        _0x4b022 = osMap[_0xf8cf9d(0x1ab)]()["lat"];
    (zoom = osMap[_0xf8cf9d(0x122)]()), (zoom2 = osMap2[_0xf8cf9d(0x122)]());
    let _0x4a4869 = zoom - 0x7;
    if (_0x4a4869 > max_zoom) _0x4a4869 = max_zoom;
    if (_0x4a4869 < min_zoom) _0x4a4869 = min_zoom;
    osMap2[_0xf8cf9d(0x1af)](new OpenLayers[_0xf8cf9d(0x163)](_0x24a1a5, _0x4b022)[_0xf8cf9d(0xf2)](new OpenLayers["Projection"](_0xf8cf9d(0xfe)), new OpenLayers[_0xf8cf9d(0x127)](_0xf8cf9d(0xf4))), _0x4a4869);
}
function init2() {
    const _0x2f6518 = _0x37a427,
        _0x5be797 = new OpenLayers[_0x2f6518(0x127)](_0x2f6518(0x1b6)),
        _0x4ae923 = new OpenLayers[_0x2f6518(0x127)](_0x2f6518(0xf4)),
        _0x1fb184 = [0x380, 0x1c0, 0xe0, 0x70, 0x38, 0x1c, 0xe, 0x7, 3.5, 1.75, 0.875],
        _0x31808b = new OpenLayers[_0x2f6518(0x11f)](-0x3a327, 0x0, 0xa6040, 0x150000),
        _0x5839b = new OpenLayers[_0x2f6518(0x11f)](0x0, 0x0, 0xa6040, 0x150000);
    (osMap2 = new OpenLayers[_0x2f6518(0x10e)]("map2", {
        div: _0x2f6518(0x13a),
        maxExtent: _0x31808b,
        resolutions: _0x1fb184,
        units: _0x2f6518(0x198),
        tileSize: new OpenLayers[_0x2f6518(0x114)](0x100, 0x100),
        projection: _0x2f6518(0xf4),
        restrictedExtent: _0x5839b,
        layers: [
            new OpenLayers[_0x2f6518(0x167)][_0x2f6518(0x111)](_0x2f6518(0x138), [osUrl + _0x2f6518(0x141) + key], {
                attribution: ![],
                tileOptions: {
                    eventListeners: {
                        loadstart: function (_0x5c360e) {
                            const _0x24bc02 = _0x2f6518;
                            var _0x23be63 = this;
                            _0x23be63[_0x24bc02(0x14c)][_0x24bc02(0x18f)] = _0x24bc02(0x120);
                        },
                        loadend: function (_0x21277a) {
                            const _0x34e0cc = _0x2f6518;
                            var _0x4c2eaf = this,
                                _0x200af0 = osMap2[_0x34e0cc(0x122)](),
                                _0x53bb9b = document[_0x34e0cc(0xfc)]("a");
                            _0x53bb9b[_0x34e0cc(0x12a)] = this[_0x34e0cc(0x104)];
                            var _0x54f8d5 = parseQuery(_0x53bb9b[_0x34e0cc(0x17f)]),
                                _0x55a0d8,
                                _0x3e4930 = [],
                                _0x48a00c,
                                _0x3a9a3d;
                            if (_0x200af0 === 0x8) {
                                if (_0x54f8d5[_0x34e0cc(0x119)][_0x34e0cc(0x121)](":" + _0x200af0) !== -0x1) {
                                    (_0x55a0d8 = _0x54f8d5[_0x34e0cc(0x119)][_0x34e0cc(0xfa)](":")), _0x55a0d8[_0x34e0cc(0x1ae)](), _0x55a0d8["push"](_0x200af0 + 0x1), (_0x55a0d8 = _0x55a0d8[_0x34e0cc(0x125)](":")), (_0x3e4930 = []);
                                    for (var _0x1fb5f6 = 0x0; _0x1fb5f6 < 0x4; _0x1fb5f6++) {
                                        if (_0x1fb5f6 < 0x2) _0x48a00c = 0x0;
                                        else {
                                            if (_0x1fb5f6 < 0x4) _0x48a00c = 0x1;
                                        }
                                        var _0x1f571c = _0x1fb5f6 % 0x2,
                                            _0x306c29 = _0x54f8d5["tileRow"] * 0x2 + _0x48a00c,
                                            _0x3686b9 = _0x54f8d5["tileCol"] * 0x2 + _0x1f571c;
                                        _0x3e4930[_0x1fb5f6] =
                                            osUrl +
                                            "?service=WMTS&request=GetTile&version=1.0.0&layer=" +
                                            _0x54f8d5[_0x34e0cc(0x187)] +
                                            _0x34e0cc(0xfb) +
                                            _0x54f8d5["format"] +
                                            _0x34e0cc(0x102) +
                                            _0x54f8d5["tileMatrixSet"] +
                                            _0x34e0cc(0x15b) +
                                            _0x55a0d8 +
                                            "&tileRow=" +
                                            _0x306c29 +
                                            "&tileCol=" +
                                            _0x3686b9 +
                                            _0x34e0cc(0x13f) +
                                            _0x54f8d5["key"];
                                    }
                                    function _0x3fbdf2(_0x240178, _0x37a0ca, _0x11c0ef) {
                                        const _0x1b6010 = _0x34e0cc;
                                        var _0x1718e2 = [];
                                        function _0x2e1cc3() {
                                            const _0x4c4f55 = _0x2d1b;
                                            if (_0x3a9a3d !== osMap2[_0x4c4f55(0x122)]()) return;
                                            if (_0xf62067 === 0x4) {
                                                var _0x5e6835 = document[_0x4c4f55(0xfc)]("CANVAS"),
                                                    _0x45b11f = _0x5e6835[_0x4c4f55(0x164)]("2d"),
                                                    _0x13f022;
                                                (_0x5e6835[_0x4c4f55(0x101)] = 0x200), (_0x5e6835[_0x4c4f55(0x183)] = 0x200);
                                                for (var _0x1006ea = 0x0; _0x1006ea < _0x1718e2[_0x4c4f55(0x10c)]; _0x1006ea++) {
                                                    if (_0x3a9a3d !== osMap2[_0x4c4f55(0x122)]()) return;
                                                    if (_0x1006ea < 0x2) _0x48a00c = 0x0;
                                                    else {
                                                        if (_0x1006ea < 0x4) _0x48a00c = 0x100;
                                                    }
                                                    var _0x23a052 = _0x1006ea % 0x2;
                                                    (_0x1f571c = _0x23a052 * 0x100), _0x45b11f[_0x4c4f55(0x105)](_0x1718e2[_0x1006ea], 0x0, 0x0, 0x100, 0x100, _0x1f571c, _0x48a00c, 0x100, 0x100);
                                                }
                                                (_0x13f022 = _0x5e6835[_0x4c4f55(0x134)](_0x11c0ef)), _0x37a0ca(_0x13f022);
                                            }
                                        }
                                        var _0xf62067 = 0x0,
                                            _0x3e682e = _0x240178[_0x1b6010(0x10c)],
                                            _0x38c204 = [];
                                        for (var _0x419dfa = 0x0; _0x419dfa < _0x3e682e; _0x419dfa++) {
                                            if (_0x3a9a3d !== osMap2[_0x1b6010(0x122)]()) return;
                                            (_0x38c204[_0x419dfa] = new Image()),
                                                (_0x38c204[_0x419dfa][_0x1b6010(0x190)] = "Anonymous"),
                                                _0x38c204[_0x419dfa][_0x1b6010(0x174)](_0x1b6010(0x158), _0x419dfa),
                                                (_0x38c204[_0x419dfa][_0x1b6010(0x135)] = function () {
                                                    const _0xbaf81a = _0x1b6010;
                                                    if (_0x3a9a3d !== osMap2[_0xbaf81a(0x122)]()) return;
                                                    (_0x1718e2[this["getAttribute"](_0xbaf81a(0x158))] = this), _0xf62067++, _0x2e1cc3();
                                                }),
                                                (_0x38c204[_0x419dfa][_0x1b6010(0x18f)] = _0x240178[_0x419dfa]);
                                        }
                                    }
                                    (_0x3a9a3d = osMap2["getZoom"]()),
                                        _0x3fbdf2(_0x3e4930, function (_0x44860a) {
                                            const _0x21e803 = _0x34e0cc;
                                            if (_0x3a9a3d !== osMap2[_0x21e803(0x122)]()) {
                                            } else (_0x4c2eaf[_0x21e803(0x14c)]["src"] = _0x44860a), _0x4c2eaf[_0x21e803(0x1b4)]();
                                        }),
                                        (_0x4c2eaf["imgDiv"]["src"] = _0x34e0cc(0x120));
                                }
                            }
                            if (_0x200af0 === 0x7) {
                                if (_0x54f8d5["tileMatrix"]["indexOf"](":" + _0x200af0) !== -0x1) {
                                    (_0x55a0d8 = _0x54f8d5["tileMatrix"][_0x34e0cc(0xfa)](":")), _0x55a0d8[_0x34e0cc(0x1ae)](), _0x55a0d8[_0x34e0cc(0xf1)](_0x200af0 + 0x2), (_0x55a0d8 = _0x55a0d8[_0x34e0cc(0x125)](":")), (_0x3e4930 = []);
                                    for (var _0x1fb5f6 = 0x0; _0x1fb5f6 < 0x10; _0x1fb5f6++) {
                                        if (_0x1fb5f6 < 0x4) _0x48a00c = 0x0;
                                        else {
                                            if (_0x1fb5f6 < 0x8) _0x48a00c = 0x1;
                                            else {
                                                if (_0x1fb5f6 < 0xc) _0x48a00c = 0x2;
                                                else {
                                                    if (_0x1fb5f6 < 0xe) _0x48a00c = 0x3;
                                                }
                                            }
                                        }
                                        var _0x1f571c = _0x1fb5f6 % 0x4,
                                            _0x306c29 = _0x54f8d5[_0x34e0cc(0x19c)] * 0x4 + _0x48a00c,
                                            _0x3686b9 = _0x54f8d5[_0x34e0cc(0x1b5)] * 0x4 + _0x1f571c;
                                        _0x3e4930[_0x1fb5f6] =
                                            osUrl +
                                            _0x34e0cc(0x13c) +
                                            _0x54f8d5[_0x34e0cc(0x187)] +
                                            _0x34e0cc(0xfb) +
                                            _0x54f8d5["format"] +
                                            _0x34e0cc(0x102) +
                                            _0x54f8d5[_0x34e0cc(0x143)] +
                                            _0x34e0cc(0x15b) +
                                            _0x55a0d8 +
                                            "&tileRow=" +
                                            _0x306c29 +
                                            "&tileCol=" +
                                            _0x3686b9 +
                                            _0x34e0cc(0x13f) +
                                            _0x54f8d5[_0x34e0cc(0x17a)];
                                    }
                                    function _0x30bed0(_0x217bbc, _0x2fc947, _0xa985c6) {
                                        const _0x4e6f82 = _0x34e0cc;
                                        var _0x54b5d5 = [];
                                        function _0x122e4c() {
                                            const _0x523bac = _0x2d1b;
                                            if (_0x3a9a3d !== osMap2[_0x523bac(0x122)]()) return;
                                            if (_0x12b10f === 0x10) {
                                                var _0x392beb = document[_0x523bac(0xfc)](_0x523bac(0x12b)),
                                                    _0x55a2e7 = _0x392beb["getContext"]("2d"),
                                                    _0x2b0c05;
                                                (_0x392beb[_0x523bac(0x101)] = 0x400), (_0x392beb["width"] = 0x400);
                                                for (var _0x556c7a = 0x0; _0x556c7a < _0x54b5d5[_0x523bac(0x10c)]; _0x556c7a++) {
                                                    if (_0x3a9a3d !== osMap2[_0x523bac(0x122)]()) return;
                                                    var _0x3fc93b;
                                                    if (_0x556c7a < 0x4) _0x3fc93b = 0x0;
                                                    else {
                                                        if (_0x556c7a < 0x8) _0x3fc93b = 0x100;
                                                        else {
                                                            if (_0x556c7a < 0xc) _0x3fc93b = 0x200;
                                                            else {
                                                                if (_0x556c7a < 0xe) _0x3fc93b = 0x300;
                                                            }
                                                        }
                                                    }
                                                    var _0x5b509a = _0x556c7a % 0x4;
                                                    (_0x1f571c = _0x5b509a * 0x100), _0x55a2e7[_0x523bac(0x105)](_0x54b5d5[_0x556c7a], 0x0, 0x0, 0x100, 0x100, _0x1f571c, _0x3fc93b, 0x100, 0x100);
                                                }
                                                (_0x2b0c05 = _0x392beb[_0x523bac(0x134)](_0xa985c6)), _0x2fc947(_0x2b0c05);
                                            }
                                        }
                                        var _0x12b10f = 0x0,
                                            _0x111855 = _0x217bbc[_0x4e6f82(0x10c)],
                                            _0x2c144f = [];
                                        for (var _0x838e2e = 0x0; _0x838e2e < _0x111855; _0x838e2e++) {
                                            if (_0x3a9a3d !== osMap2["getZoom"]()) return;
                                            (_0x2c144f[_0x838e2e] = new Image()),
                                                (_0x2c144f[_0x838e2e][_0x4e6f82(0x190)] = _0x4e6f82(0x1a0)),
                                                _0x2c144f[_0x838e2e][_0x4e6f82(0x174)]("data-id", _0x838e2e),
                                                (_0x2c144f[_0x838e2e][_0x4e6f82(0x135)] = function () {
                                                    const _0x5bb3f2 = _0x4e6f82;
                                                    if (_0x3a9a3d !== osMap2[_0x5bb3f2(0x122)]()) return;
                                                    (_0x54b5d5[this["getAttribute"]("data-id")] = this), _0x12b10f++, _0x122e4c();
                                                }),
                                                (_0x2c144f[_0x838e2e][_0x4e6f82(0x18f)] = _0x217bbc[_0x838e2e]);
                                        }
                                    }
                                    (_0x3a9a3d = osMap2[_0x34e0cc(0x122)]()),
                                        _0x30bed0(_0x3e4930, function (_0xd11a21) {
                                            const _0x46380b = _0x34e0cc;
                                            if (_0x3a9a3d !== osMap2["getZoom"]()) {
                                            } else (_0x4c2eaf[_0x46380b(0x14c)][_0x46380b(0x18f)] = _0xd11a21), _0x4c2eaf[_0x46380b(0x1b4)]();
                                        }),
                                        (_0x4c2eaf["imgDiv"][_0x34e0cc(0x18f)] = _0x34e0cc(0x120));
                                }
                            }
                        },
                    },
                },
            }),
        ],
    })),
        osMap2[_0x2f6518(0x13b)][_0x2f6518(0x11b)](_0x2f6518(0x14b), osMap2, function () {
            const _0x497301 = _0x2f6518;
            zoom = osMap2["getZoom"]();
            if (osMap2[_0x497301(0x10b)] < 0x7) {
                var _0x573893 = transform2["center"],
                    _0x14b7d9,
                    _0x45647d;
                _0x573893["x"] ? ((_0x14b7d9 = _0x573893["x"]), (_0x45647d = _0x573893["y"])) : ((_0x14b7d9 = osMap2[_0x497301(0x10f)][_0x497301(0xf9)]), (_0x45647d = osMap2[_0x497301(0x10f)][_0x497301(0x1a6)])),
                    osMap2["setCenter"](new OpenLayers["LonLat"](_0x14b7d9, _0x45647d), 0x7);
            }
        });
    var _0x16246e = new OpenLayers[_0x2f6518(0x146)]({ fillColor: _0x2f6518(0x179), fillOpacity: _0x2f6518(0x178), strokeWidth: 0x1 });
    (vectors2 = new OpenLayers[_0x2f6518(0x167)][_0x2f6518(0x147)](_0x2f6518(0x177), { displayInLayerSwitcher: ![], styleMap: _0x16246e })),
        osMap2["addLayer"](vectors2),
        (box2 = new OpenLayers[_0x2f6518(0x14f)][_0x2f6518(0x1b7)](vectors2, OpenLayers[_0x2f6518(0x112)][_0x2f6518(0x11c)], { handlerOptions: { sides: 0x4, snapAngle: 0x5a, irregular: !![], persist: !![] } })),
        osMap2[_0x2f6518(0x18e)](box2),
        (transform2 = new OpenLayers[_0x2f6518(0x14f)][_0x2f6518(0x15c)](vectors2, { rotate: ![], irregular: !![], preserveAspectRatio: !![] })),
        osMap2[_0x2f6518(0x18e)](transform2),
        osMap2[_0x2f6518(0x18e)](box2),
        osMap2[_0x2f6518(0x1af)](new OpenLayers[_0x2f6518(0x163)](setup_position[0x0], setup_position[0x1])["transform"](_0x5be797, _0x4ae923), 0x9);
}
window[_0x37a427(0x169)](_0x37a427(0x1b9), function () {
    const _0x2dba5d = _0x37a427,
        _0xdee985 = document[_0x2dba5d(0x118)](_0x2dba5d(0x110));
    (range = document["getElementById"](_0x2dba5d(0x109))),
        init(),
        window.CMAP_REFERENCE_ONLY || init2(),
        initSmooths(),
        (range["disabled"] = !![]),
        _0xdee985[_0x2dba5d(0x169)](_0x2dba5d(0x176), function () {
            const _0x59c3f7 = _0x2dba5d,
                _0x2f7aa0 = document[_0x59c3f7(0x118)]("map");
            _0x2f7aa0[_0x59c3f7(0xf7)]["display"] === _0x59c3f7(0x154) ? (setMainMap(), isBoxShowed && (range[_0x59c3f7(0x16c)] = ![])) : (setSecondMap(), centerTwoMaps(), redrawBoxToMap2(), (range[_0x59c3f7(0x16c)] = !![]));
        }),
        (range[_0x2dba5d(0x11d)] = 0xfa),
        range[_0x2dba5d(0x169)]("input", function (_0x384ddc) {
            const _0x3955e0 = _0x2dba5d,
                _0x449bc9 = _0x384ddc["target"]["value"] - 0xfa;
            !cathed && ((cathed = !![]), (catchBounds = transform["box"][_0x3955e0(0x106)][_0x3955e0(0x170)])), rangeBoxResize(_0x449bc9);
        }),
        range[_0x2dba5d(0x169)](_0x2dba5d(0x12c), function (_0x4de8b6) {
            const _0x277080 = _0x2dba5d;
            cathed = ![];
            const _0x651000 = _0x4de8b6[_0x277080(0x144)]["value"] - 0xfa;
            _0x4de8b6[_0x277080(0x144)][_0x277080(0x11d)] = 0xfa;
        });
});

window.addEventListener("DOMContentLoaded", function () {
    if (cmapHubDimensions) {
        ['inpWi', 'inpHe'].forEach(function (id) {
            document.getElementById(id).addEventListener('input', function () { cmapUpdateDimensionCrop(false); });
        });
    }
    document.addEventListener("click", function (event) {
        var control = event.target.closest("[data-cmap-zoom]");
        if (!control || !window.CMAP_REFERENCE_ONLY || !osMap) return;
        event.preventDefault();
        event.stopPropagation();
        if (control.getAttribute("data-cmap-zoom") === "in") osMap.zoomIn();
        else osMap.zoomOut();
    }, true);
});
function initSmooths() {
    const _0x1ce267 = _0x37a427,
        _0x1e9eda = document[_0x1ce267(0x118)]("mapSmooths"),
        _0x353cd2 = document[_0x1ce267(0xfc)](_0x1ce267(0x18b));
    (_0x353cd2["id"] = "smoothsSelect"), _0x1e9eda[_0x1ce267(0x162)](_0x353cd2);
    for (const _0x293ca9 in smooths) {
        if (smooths[_0x1ce267(0x18d)](_0x293ca9)) {
            const _0x11a9e1 = document[_0x1ce267(0xfc)]("option");
            (_0x11a9e1["value"] = _0x293ca9),
                (_0x11a9e1["text"] = _0x293ca9),
                smooths[_0x293ca9][_0x1ce267(0x197)] !== undefined && (_0x11a9e1[_0x1ce267(0x197)] = smooths[_0x293ca9][_0x1ce267(0x197)]),
                _0x353cd2[_0x1ce267(0x162)](_0x11a9e1);
        }
    }
    _0x353cd2[_0x1ce267(0x169)](_0x1ce267(0x12c), function () {
        calculatePrice();
    });
}
